import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProgressBarProps {
  current: number;
  total: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const { t } = useTranslation('trivia');

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-blue-300 font-medium">
          {t('progress', { current, total })}
        </span>
        <span className="text-sm text-gray-400">{Math.round((current / total) * 100)}%</span>
      </div>
      <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
        <div
          className="h-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-400 score-bar-fill"
          style={{ width: `${(current / total) * 100}%` }}
        />
      </div>
      <div className="flex gap-1 mt-2">
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={i}
            className={`flex-1 h-1 rounded-full transition-colors duration-300 ${
              i < current ? 'bg-blue-500' : 'bg-white/20'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
